import { useSelector } from 'react-redux'

export default function useUser() {
  return useSelector((state: any) => state?.authSlice?.user)
}

export function useAuth() {
  return useSelector((state: any) => state?.authSlice?.token)
}
